import { Typename } from 'src/constants/typenames'
import { types } from 'mobx-state-tree'
import { fromGlobalId, toGlobalId } from 'src/api/utils/globalId'
import { v4 as uuid } from 'uuid'

export const generateNodeId = (type: Typename) =>
  types.optional(
    types.refinement(types.identifier, id => fromGlobalId(id).type === type),
    () => toGlobalId(type, uuid())
  )
